import modal from './modal';
import bind from './bind';

export default (editor, opts = {}) => {
    const $ = editor.$;
    const pfx = editor.getConfig().stylePrefix;
    const mdlClass = `${pfx}mdl-dialog-wx`;
    let primaryEl = '';
    let menusEl;
    const domEl = $(`#${pfx}mdl-help`);
    const menus = ['Discord', '', 'Video Tutorials', 'Documentation', 'Dev Mode', '',
        'Why Upgrade?', 'Submit Feedback', 'Privacy Policy', 'Terms & Conditions'
    ];
    menus.forEach(menu => {
        primaryEl += `<div data-filter="${menu}">${menu}</div>`
    });
    menusEl = domEl.length ? domEl :
        $(`<div id="${pfx}mdl-help" class="${pfx}mdl-options-container ${pfx}fadein">
            <div class="${pfx}mdl-options-primary">${primaryEl}</div>
            <div class="${pfx}mdl-illustration"></div>
        </div>`);

    !domEl.length && bind(pfx, menusEl, {
        id: 'help',
        ...opts
    });

    modal(editor, mdlClass, 'Help', menusEl.get(0));
};